import type { Page } from '../../types';

const aboutYou: Page[] = [
  {
    pageType: 'question',
    title: 'About you',
    name: 'about-you',
    description:
      'Register your interest in trialling access to large language models (LLMs). The trial will help your team test a real use case, understand potential benefits and estimate ongoing costs. We will use your answers to assess your request and contact you about next steps.',
    questions: [
      {
        questionType: 'textInput',
        title: 'Full name',
        name: 'full-name',
        userNameFromEmail: true,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Work email address',
        name: 'work-email-address',
        userEmail: true,
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Department or organisation',
        name: 'department-or-organisation',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Team name',
        name: 'team-name',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Directorate or business area',
        name: 'directorate-or-business-area',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default aboutYou;
